import axios from 'axios'
const ApiPlayer = {
	install (Vue) {
		Vue.prototype.$ApiPlayer = {
			encryption_keys (options) {
				return new Promise((resolve, reject) => {
					const config = {
						headers: { 'content-type': 'application/json' }
					}
					axios.post(window.appConfig._$acomz6 + 'player/encryption_keys', options, config)
						.then(res => (resolve(res.data.encryption_keys)))
						.catch(reject)
				})
			},
			signed_cookie (options) {
				return new Promise((resolve, reject) => {
					const config = {
						headers: {
							'content-type': 'application/json',
							'accept': 'application/json'
						},
						withCredentials: true
					}
					axios.post(window.appConfig._$acomz6 + 'player/signed_cookie', options, config)
						.then(res => resolve(res.data))
						.catch(reject)
				})
			},
			signed_url (options) {
				return new Promise((resolve, reject) => {
					const config = {
						headers: {
							'content-type': 'application/json',
							'accept': 'application/json'
						}
					}
					axios.post(window.appConfig._$acomz6 + 'player/signed_url', options, config)
						.then(res => (resolve(res.data)))
						.catch(reject)
				})
			}
		} // End prototype definition
	} // End Install
} // End plugin

export default ApiPlayer



// WEBPACK FOOTER //
// ./src/services/api_player.js